import Base from "./Base";

export default class Calendar extends Base {
    getDates = async (date, city) => {
        let params = new URLSearchParams();
        if(document.getElementById("app") !== null) {
            let data = JSON.parse(document.getElementById("app").attributes.getNamedItem("data-data").value);
            params.append("city", data.city);
        }

        if(city) {
            params.append("city", city);
        }

        if(date) {
            params.append("date", date);
        }

        return await this.getResource(`/calendar/dates?${params.toString()}`, {
            method: "get"
        });
    };
}